// extracted by mini-css-extract-plugin
export default {"page":"App_page__JhKbl","flareAnimation":"App_flareAnimation__bQupF"};